import { defineStore } from "pinia";
import { useMyAdsFeedStore } from "@/smart-feed/stores/feed/my-ads-feed-store";

export const usePublicationAdsStore = defineStore("publication-ads-store", {
  state: () => ({
    isDisableAdsLoading: false,
    isEnableAdsLoading: false,
    isCreateAdLoading: false,
    isLoadingUploadAdImage: false,
    adActionError: null,
    isCreateAdModalOpen: false,
    randomAd: null,
  }),
  actions: {
    openCreateAdModal() {
      this.isCreateAdModalOpen = true;
    },

    closeCreateAdModal() {
      this.isCreateAdModalOpen = false;
    },
    enableAds(publicationId, onSuccess = () => {}, onError = () => {}) {
      if (this.isEnableAdsLoading) {
        return;
      }

      this.isEnableAdsLoading = true;
      this.adActionError = null;

      this.apiPost(
        `/publication/${publicationId}/ads/enable`,
        {},
        () => {
          this.isEnableAdsLoading = false;
          onSuccess();
        },
        error => {
          this.isEnableAdsLoading = false;
          onError();
          this.adActionError =
              error.response?.data?.message || "Failed to enable ads for this publication";
        },
      );
    },
    disableAds(publicationId, onSuccess = () => {}, onError = () => {}) {
      if (this.isDisableAdsLoading) {
        return;
      }

      this.isDisableAdsLoading = true;
      this.adActionError = null;

      this.apiPost(
        `/publication/${publicationId}/ads/disable`,
        {},
        () => {
          this.isDisableAdsLoading = false;
          onSuccess();
        },
        error => {
          this.isDisableAdsLoading = false;
          onError();
          this.adActionError =
              error.response?.data?.message || "Failed to disable ads for this publication";
        },
      );
    },
    createAd({
      publicationId,
      name,
      title,
      imageUrl,
      description,
      sponsoredByPrefix,
      destinationUrl,
    }) {
      if (this.isCreateAdLoading) {
        return;
      }

      this.isCreateAdLoading = true;
      this.adActionError = null;

      this.apiPost(
        `/publication/${publicationId}/ads/create`,
        {
          name,
          title,
          image_url: imageUrl,
          description,
          sponsored_by_prefix: sponsoredByPrefix,
          destination_url: destinationUrl,
        },
        () => {
          this.isCreateAdLoading = false;
          this.closeCreateAdModal();
          useMyAdsFeedStore().reload();
        },
        error => {
          this.isCreateAdLoading = false;
          this.adActionError =
            error.response?.data?.message || "Failed to create ad";
        },
      );
    },

    uploadAdImage(file, adId, onSuccess = () => {}, onError = () => {}) {
      let formData = new FormData();
      formData.append("image", file);
      formData.append("ad_id", adId || 0);
      this.isLoadingUploadAdImage = true;

      return this.apiPost(
        "/publication/ad/image/upload",
        formData,
        response => {
          this.isLoadingUploadAdImage = false;
          onSuccess(response.url);
        },
        error => {
          this.isLoadingUploadAdImage = false;
          onError(error);
        },
      );
    },
    fetchRandomAd(
      publicationId,
      successHandler = () => {},
      errorHandler = () => {},
      finallyHandler = () => {},
    ) {
      return this.apiGet(
        `/publication/${publicationId}/ad/random`,
        {},
        response => {
          this.randomAd = response.ad;
          successHandler(response.ad);
        },
        errorHandler,
        finallyHandler,
      );
    },
  },
});
